import {
    InfoCircleOutlined, PlusOutlined, UnorderedListOutlined, AreaChartOutlined, BarChartOutlined, TeamOutlined, UnlockOutlined
} from '@ant-design/icons';
import { Menu } from "antd";
import SubMenu from "antd/lib/menu/SubMenu";
import { AuthContext } from 'context/auth';
import { useContext } from 'react';
import { NavLink, useLocation } from "react-router-dom";
import { checkUserHasRole } from 'utils/helpers/user_helpers';

const SidebarMenu = () => {
    const { appDomain, currentUser } = useContext(AuthContext);
    //assigning location variable
    const location = useLocation();

    const isActive = (path) => {
        //destructuring pathname from location
        const { pathname } = location;

        //Javascript split method to get the name of the path in array
        const splitLocation = pathname.split("/");
        return splitLocation[1] === path ? true : false;
    }

    return (
        <Menu
            mode="inline"
            //defaultSelectedKeys={['home']}
            //defaultOpenKeys={['home']}
            style={{ height: '100%', borderRight: 0 }}
        >
            <Menu.Item className={isActive("") ? "ant-menu-item-selected" : ""} key="home" icon={<InfoCircleOutlined />}><NavLink to="/">Home</NavLink></Menu.Item>
            {
                appDomain === 'ForestView' &&
                <Menu.Item className={isActive("forestview") ? "ant-menu-item-selected" : ""} key="forestview" icon={<BarChartOutlined />}><NavLink to="/forestview">ForestView</NavLink></Menu.Item>
            }
            {
                appDomain === 'AirTree' &&
                <SubMenu key="airtree" icon={<AreaChartOutlined />} title="AirTree">
                    <Menu.Item className={isActive("airtree-list") ? "ant-menu-item-selected" : ""} key="airtree_list"><NavLink to="/airtree-list"><UnorderedListOutlined /> Lista progetti</NavLink></Menu.Item>
                    <Menu.Item className={isActive("airtree-create") ? "ant-menu-item-selected" : ""} key="airtree_create"><NavLink to="/airtree-create"><PlusOutlined /> Nuovo progetto</NavLink></Menu.Item>
                    <Menu.Item className={isActive("airtree-public-list") ? "ant-menu-item-selected" : ""} key="airtree_public_list"><NavLink to="/airtree-public-list"><UnlockOutlined /> Progetti pubblici</NavLink></Menu.Item>
                </SubMenu>
            }
            {checkUserHasRole(currentUser, ['Admin']) &&
                <Menu.Item key="users" icon={<TeamOutlined />}><NavLink to="/users">Utenti</NavLink></Menu.Item>
            }
        </Menu>
    )
}

export default SidebarMenu;